// Which /bestsellers tab a URL names. Pure, and deliberately imports NOTHING.
//
// ⚠️ Kept separate from `tabs.ts` for the reason `dashboard/logTabs.tsx` records: that module
// imports `../../api`, whose module body reaches `lib/server` and reads
// `window.location.origin`. Anything importing it therefore needs a DOM, so the routing
// helpers — which are four string comparisons and are what the tests and the SSR page care
// about — live here where they can be read without one.

export const BESTSELLER_TABS = [
  { id: "mine", label: "Your top sellers", path: "/bestsellers" },
  { id: "rec", label: "Recommended", path: "/bestsellers/recommended" },
  { id: "upload", label: "Upload bestsellers", path: "/bestsellers/upload" },
  { id: "global", label: "Global top sellers", path: "/bestsellers/global" },
] as const;

export type BestsellerTab = (typeof BESTSELLER_TABS)[number]["id"];

export const DEFAULT_TAB: BestsellerTab = "mine";

/**
 * Which tab a URL names.
 *
 * The bare `/bestsellers` is the default tab, so every link that existed before the rebuild
 * still lands somewhere sensible. An unknown segment does too, rather than 404ing a tab.
 */
export function tabFromPath(pathname: string): BestsellerTab {
  const seg = pathname.replace(/\/+$/, "").split("/")[2] ?? "";
  if (seg === "recommended") return "rec";
  if (seg === "upload") return "upload";
  if (seg === "global") return "global";
  return DEFAULT_TAB;
}

export function tabHref(tab: BestsellerTab): string {
  return BESTSELLER_TABS.find((t) => t.id === tab)?.path ?? "/bestsellers";
}

/** The tab on screen. Guarded for the node-environment tests, which have no `location`. */
export function currentTab(): BestsellerTab {
  return typeof location === "undefined" ? DEFAULT_TAB : tabFromPath(location.pathname);
}
